import { render, staticRenderFns } from "./Popover.vue?vue&type=template&id=2ff5c61c&scoped=true&lang=pug&"
import script from "./Popover.vue?vue&type=script&lang=js&"
export * from "./Popover.vue?vue&type=script&lang=js&"
import style0 from "./Popover.vue?vue&type=style&index=0&id=2ff5c61c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff5c61c",
  null
  
)

export default component.exports